module.exports = __webpack_public_path__ + "static/media/AvailableXp.ff4386b3.svg";